import React from 'react';
import { languageLink } from "../lib/Formats";
import {Button, useLocaleState, useRecordContext, useRefresh} from "react-admin";

export const SwitchLanguageButton = () => {
    const [locale, setLocale] = useLocaleState();
    const refresh = useRefresh();

    const switchToWelsh = () => {
        setLocale('cy');
        refresh();
    };

    const switchToEnglish = () => {
        setLocale('en');
        refresh();
    };

    if(locale === 'en') 
        return <Button onClick={switchToWelsh} label="Ferswn Cymraig" />;
    else 
        return <Button onClick={switchToEnglish} label="English Version" />;

};

const CourseLanguageLinkField = ()  => {

    const record = useRecordContext();
    const [, setLocale] = useLocaleState();

    const switchToWelsh = () => setLocale('cy');
    const switchToEnglish = () => setLocale('en');

    return (record ?
        !record.id.endsWith('C') ?
            <div>
                <a style={languageLink} href={`/#/Course/${record.id}C/show`} onClick={switchToWelsh}>
                    Ferswn Cymraig
                </a>
            </div>
            :
            <div>
                <a style={languageLink} href={`/#/Course/${record.id.substring(0, record.id.length - 1)}/show`} onClick={switchToEnglish}>
                    English Version
                </a>
            </div>
        : null )


}

export default CourseLanguageLinkField